import type { ReactNode } from 'react';
import React, { useState } from 'react';
import type { TextFieldProps } from '@mui/material';
import { TextField, FormControl } from '@mui/material';
import * as S from '../containers/PropertyPanel/PropertyPanel.styles';

export interface StringInputInterface {
  value: string | undefined;
  setValue(val: string): void;
  label: string;
  marginRight?: number;
  endAdornment?: ReactNode;
  disabled?: boolean;
  multiLine?: boolean;
  minRows?: number;
  maxRows?: number;
  rows?: number;
  adornmentShownByDefault?: boolean;
  startAdornment?: ReactNode;
  autoFocus?: boolean;
  onBlur?: TextFieldProps['onBlur'];
}

export const StringInput = ({
  value,
  setValue,
  label,
  marginRight,
  endAdornment,
  disabled,
  multiLine,
  minRows,
  maxRows,
  rows,
  adornmentShownByDefault,
  startAdornment,
  autoFocus,
  onBlur,
}: StringInputInterface) => {
  const [showAdornment, setShowAdornment] = useState(!!adornmentShownByDefault);

  return (
    <S.FormWrapper spaceRight={marginRight}>
      <FormControl
        id={`label-${label}`}
        variant='filled'
        fullWidth
        onMouseEnter={() => !adornmentShownByDefault && setShowAdornment(true)}
        onMouseLeave={() => !adornmentShownByDefault && setShowAdornment(false)}
      >
        <TextField
          label={label}
          variant='filled'
          multiline={multiLine}
          minRows={minRows}
          maxRows={maxRows}
          rows={rows}
          value={typeof value === 'string' ? value : ''}
          color='info'
          fullWidth
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setValue(e.target.value.toString())
          }
          onBlur={onBlur}
          disabled={disabled}
          autoFocus={autoFocus}
          onFocus={(e) => {
            if (autoFocus) {
              e.target.select();
            }
          }}
          slotProps={{
            input: {
              endAdornment: showAdornment && endAdornment,
              startAdornment: showAdornment && startAdornment,
            },

            htmlInput: {
              type: 'string',
            },
          }}
        />
      </FormControl>
    </S.FormWrapper>
  );
};
